export default "__VITE_ASSET__C8mTiDid__"